import React, { ReactElement } from 'react';
import '../style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { PagePath } from 'constants/pagePath';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { useNavigate } from 'react-router-dom';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';

export const EntryComplete = (props: TemplateProps) => {
  const navigate = useNavigate();

  useCustomLocationName('口座開設申込みフォーム');

  return (
    <>
      {!props.isUpdate && (
        <div className="personalAccountOpenTemplate">
          <div className="personalAccountOpenTemplate_complete">
            <Description
              label="口座開設のお申込み、誠にありがとうございました。"
              labelColor={labelColor.black}
              labelSize={labelSize.massive}
            />
            <Description
              label="口座開設のお申込みを受け付けました。"
              labelColor={labelColor.gray}
              labelSize={labelSize.large}
            />
            <Description
              label="ご登録いただいたメールアドレス宛にメールを送付しましたので、引き続きお手続きをお願いいたします。"
              labelColor={labelColor.gray}
              labelSize={labelSize.large}
            />
          </div>
          <div className="personalAccountOpenTemplate_button">
            <Button
              label="TOPに戻る"
              buttonFill={ButtonFill.link}
              buttonSize={ButtonSize.extraLarge}
              onClick={() => navigate(PagePath.Login)}
            />
          </div>
        </div>
      )}
      {props.isUpdate && (
        <>
          <Description label="登録情報変更が完了しました" labelColor={labelColor.gray} labelSize={labelSize.large} />
          <div className="personalAccountOpenTemplate_button">
            <Button
              label="HOMEに戻る"
              buttonFill={ButtonFill.link}
              buttonSize={ButtonSize.small}
              onClick={() => navigate(PagePath.Home)}
            />
          </div>
        </>
      )}
    </>
  );
};
